var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { toEthereumAddress, toUserIdRaw, SigningUtil } from '@streamr/utils';
import { Lifecycle, scoped } from 'tsyringe';
import { ERC1271ContractFacade } from '../contracts/ERC1271ContractFacade';
import { StreamrClientError } from '../StreamrClientError';
import { createLegacySignaturePayload } from './createLegacySignaturePayload';
import { createSignaturePayload } from './createSignaturePayload';
import { SignatureType } from '@streamr/trackerless-network';
import { IDENTITY_MAPPING } from '../identity/IdentityMapping';
// Lookup structure SignatureType -> SigningUtil
const signingUtilBySignatureType = Object.fromEntries(IDENTITY_MAPPING.map((idMapping) => [idMapping.signatureType, SigningUtil.getInstance(idMapping.keyType)]));
const evmSigner = SigningUtil.getInstance('ECDSA_SECP256K1_EVM');
let SignatureValidator = class SignatureValidator {
    erc1271ContractFacade;
    constructor(erc1271ContractFacade) {
        this.erc1271ContractFacade = erc1271ContractFacade;
    }
    /**
     * Checks that the signature in the given StreamMessage is cryptographically valid.
     * Resolves if valid, rejects otherwise.
     */
    async assertSignatureIsValid(streamMessage) {
        let success;
        try {
            success = await this.validate(streamMessage);
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new StreamrClientError(`An error occurred during address recovery from signature: ${err}`, 'INVALID_SIGNATURE', streamMessage);
        }
        if (!success) {
            throw new StreamrClientError('Signature validation failed', 'INVALID_SIGNATURE', streamMessage);
        }
    }
    async validate(streamMessage) {
        const signingUtil = signingUtilBySignatureType[streamMessage.signatureType];
        // Common case
        if (signingUtil) {
            return signingUtil.verifySignature(toUserIdRaw(streamMessage.getPublisherId()), createSignaturePayload(streamMessage), streamMessage.signature);
        }
        // Special handling: different payload computation, same SigningUtil
        if (streamMessage.signatureType === SignatureType.ECDSA_SECP256K1_LEGACY) {
            return evmSigner.verifySignature(
            // publisherId is hex encoded Ethereum address string
            toUserIdRaw(streamMessage.getPublisherId()), createLegacySignaturePayload(streamMessage), streamMessage.signature);
        }
        // Special handling: check signature with ERC-1271 contract facade
        if (streamMessage.signatureType === SignatureType.ERC_1271) {
            return this.erc1271ContractFacade.isValidSignature(toEthereumAddress(streamMessage.getPublisherId()), createSignaturePayload(streamMessage), streamMessage.signature);
        }
        throw new Error(`Cannot validate message signature, unsupported signatureType: "${streamMessage.signatureType}"`);
    }
};
SignatureValidator = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [ERC1271ContractFacade])
], SignatureValidator);
export { SignatureValidator };
//# sourceMappingURL=SignatureValidator.js.map